import { render, staticRenderFns } from "./PagamentosEletronicosVisualizarPagamentosEletronicosView.vue?vue&type=template&id=764b6989&scoped=true"
import script from "./PagamentosEletronicosVisualizarPagamentosEletronicosView.vue?vue&type=script&setup=true&lang=js"
export * from "./PagamentosEletronicosVisualizarPagamentosEletronicosView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PagamentosEletronicosVisualizarPagamentosEletronicosView.vue?vue&type=style&index=0&id=764b6989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b6989",
  null
  
)

export default component.exports